import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import DocumentCard from "./DocumentCard";
import { displayIcon } from "variables/icons";
import {
    getEmployeeDocumentList,
} from "../../../../redux/document/documentState";

const MyDocuments = ({ employeeId }) => {
    
    const dispatch = useDispatch();
    const documentList = useSelector((state) => state.document.employeeDocumentList?.items);

    useEffect(() => {
        if (!employeeId) return;

        dispatch(getEmployeeDocumentList({
            recordId: employeeId,
            employee_id: employeeId,
        }));
    }, [dispatch, employeeId]);

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 dark-mode-card">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6">
                <h4 className="leading-none flex items-center gap-2 title-text">
                    {displayIcon(
                        "FileText",
                        "w-5 h-5 text-emerald-600 dark:text-emerald-500"
                    )}
                    My Documents
                </h4>

                <p className="muted-text">
                    Access your employment documents
                </p>
            </div>

            <div className="px-6 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {documentList?.map((doc) => (
                        <DocumentCard
                            key={doc.doc_id}
                            documentData={doc}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default MyDocuments;